<script lang="ts">

    import type { Route } from "../Model/Route";
    import Marker from './Marker.svelte';
    import { distanceCalculator, geolocation } from '../Services';
    import type ChallengePoint from "../Model/ChallengePoint";
    import type { Coordinates } from "../global";
    import { DISTANCE_TO_INTERACTIVE } from "../environment";
    
    export let route: Route;
    export let challengePoint: ChallengePoint;

    const markerSize = 55;
    const userCoords = geolocation.coords;
    const isCompleted = challengePoint.isCompleted;
    
    let icon = route.getTrivialIcon('block');
    let isAccesible: boolean = false;
    
    $: icon = updateIcon($userCoords, $isCompleted);

    function updateIcon(userCoords: Coordinates | null, isCompleted: boolean): string {

        isAccesible = false;

        if (isCompleted) {
            return route.getTrivialIcon('completed');
        }

        if (!userCoords) {
            return route.getTrivialIcon('block');
        }

        const distance = distanceCalculator.calcDistance(challengePoint.coords, userCoords);

        if (distance > DISTANCE_TO_INTERACTIVE) {
            return route.getTrivialIcon('block'); 
        }

        isAccesible = true;
        return route.getTrivialIcon('accesible');
    }

</script>

<style lang="scss">

    .marker-icon {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

</style>

<Marker
    coordinates={challengePoint.coords}
    width={markerSize}
    height={markerSize}
    zIndex={5}
    anchor="center"
    on:click>
    <img class:boing-animation={isAccesible} class="marker-icon" src={icon} alt="">
</Marker>
